import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '1rem'
  },
  panel: {
    width: '30rem',
    minWidth: '20rem',
  },
  teamPanel: {
    display: 'flex',
    justifyContent: 'center'
  },
  preTitle: {
    fontSize: '18px',
    fontWeight: '400',
    color: '#dddddd'
  },
  mainIcon: {
    width: '15rem',
    height: '15rem',
  },
  mainTitle: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#ffffff'
  },
  content: {
    fontSize: '16px',
    color: '#ffffff'
  },
}));

export default function HomePageSectionFour() {

  const classes = useStyles();

  return (
    <Grid container direction="row" spacing={0} alignItems="center" className={classes.root}>
      <div className={classes.panel}>
        <Typography className={classes.preTitle}>
          Global Developer Relations Team
        </Typography>
        <Typography className={classes.mainTitle}>
          A dedicated team to serve a community of experts
        </Typography>
        <Typography className={classes.content}>
          Symphony Developer Relations is a team of experienced Symphony developers supporting and building our developer community. We promote the capabilities of the Symphony platform API and the tools that are available.
        </Typography>
      </div>
      <div className={classes.teamPanel}>
        <img src="teamicon.svg" className={classes.mainIcon} alt="Team" />
      </div>
    </Grid>
  );
}
